import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Filters} from "../authorized-activities/authorized-activities.component";
import {FormBuilder, FormGroup} from "@angular/forms";


@Component({
  selector: 'app-export-auth-activities',
  templateUrl: './export-auth-activities.component.html',
  styleUrl: './export-auth-activities.component.scss',
  standalone: false
})
export class ExportAuthActivitiesComponent {

  filters: Filters = {
    calendarYear: null,
    fiscalYear: null,
    region: null,
    forestName: null,
    treatmentOptionId: null,
  };
  formGroup!: FormGroup;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<ExportAuthActivitiesComponent>,
  ) {
    this.formGroup = this.fb.group({
      calendarYearCheck: [true],
      fiscalYearCheck: [true],
      regionCheck: [true],
      forestNameCheck: [true],
      treatmentOptionIdCheck: [true],
    });
  }

  onCalendarYearChange(year: number | null): void {
    this.filters.calendarYear = year;
  }

  onFiscalYearChange(fy: number | null): void {
    this.filters.fiscalYear = fy;
  }

  onRegionChange(region: string | null): void {
    this.filters.region = region;
  }

  onForestChange(forestName: string | null): void {
    this.filters.forestName = forestName;
  }

  onTreatmentChange(optionId: number | null): void {
    this.filters.treatmentOptionId = optionId;
  }

  exportToCsv() {
    if (!this.formGroup.value.calendarYearCheck) {
      this.filters.calendarYear = null;
    }
    if (!this.formGroup.value.fiscalYearCheck) {
      this.filters.fiscalYear = null;
    }
    if (!this.formGroup.value.regionCheck) {
      this.filters.region = null;
    }
    if (!this.formGroup.value.forestNameCheck) {
      this.filters.forestName = null;
    }
    if (!this.formGroup.value.treatmentOptionIdCheck) {
      this.filters.treatmentOptionId = null;
    }
    this.dialogRef.close(this.filters);
  }
}
